import history from "../../helpers/History";
import * as types from "../constants/AuthConstants";
import { login as _login } from "../../services/UsuarioService";

export const login = (usercode, password) => async dispatch => {
  _login(usercode, password)
    .then(result => {
      sessionStorage.setItem("token", result.data);
      dispatch({
        type: types.LOGIN_SUCCESS
      });
      if (history.location.pathname === "/login") {
        history.push("/faturamento/" + sessionStorage.getItem("fatura"));
      }
    })
    .catch(error => {
      dispatch({
        type: types.LOGIN_FAILURE,
        error: error.message
      });
    });
};

export const logout = () => async dispatch => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("user");

  dispatch({
    type: types.LOGOUT
  });
  // await _logout();
};
